
import React from 'react'
import {connect} from "react-redux";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import PropTypes from "prop-types";
import "../resources/css/opcionesConImagenes.css";
import {Button, Dialog, Icon} from "@blueprintjs/core";



const opciones = [
    { id: '0', texto: 'NO DEFINIDO'},
    { id: '1', texto: 'SALA ESPERA', img: require('../resources/images/sala_espera.png')},
    { id: '2', texto: 'GABINETE', img: require('../resources/images/gabinete.png')},
    { id: '3', texto: 'ESPERANDO ANESTESIA', img: require('../resources/images/anestesia.png')},
    { id: '4', texto: 'ESPERANDO DESPACHO', img: require('../resources/images/despacho.png')},
    { id: '5', texto: 'DESPACHO', img: require('../resources/images/despacho.png')},
    { id: '6', texto: 'FUERA'},
];
class SalaesperaSeleccion extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    seleccionar = (id) => {
        const {onAceptar} = this.props;
        console.log("ACEPTAR ", id);
        onAceptar && onAceptar(id);
    };

    cancelar = () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {
        const {estadoSeleccionado} = this.state;
        const {isOpen, onAceptar, onCancelar, titulo, mensaje} = this.props;

        return (
        <Dialog
            isOpen={isOpen}
            onClose={onCancelar}
            title={
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>{titulo}</div>
            }
        >
            <div className="bp3-dialog-body">
                <div className="opciones-container">
                    {opciones.map(op => (
                        <div
                            key={op.id}
                            className={
                                'opcion-item' +
                                (this.state.seleccionada === op.id ? ' seleccionada' : '')
                            }
                            onClick={() => this.seleccionar(op.id)}
                        >
                            {/* Contenedor fijo para mantener alineación */}
                            <div className="opcion-imagen">
                                {op.img && <img src={op.img} alt={op.texto} />}
                            </div>

                            <span>{op.texto}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bp3-dialog-footer">
                <div className="bp3-dialog-footer-actions">
                    <Button intent="primary" onClick={this.cancelar}>
                        Cancelar
                    </Button>
                </div>
            </div>
        </Dialog>
        );


    }

}

SalaesperaSeleccion.propTypes = {
    isOpen: PropTypes.bool,
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
    salaespera: PropTypes.object,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(SalaesperaSeleccion);



